exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon[data-v-6d2f52ac]{width:1.25rem}.dropdown-item[data-v-6d2f52ac]:active,.dropdown-item[data-v-6d2f52ac]:focus{background-color:#f9f9f9}.dropdown-item i[data-v-6d2f52ac]{color:#9fabb8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d2f52ac","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Header/HeaderDropdownAccnt.vue
// module id = XcQW
// module chunks = 1